<template>
	<div class="list-view" ref="listView">
		
		<div class="title" v-if="title"> 
			<div>{{title}}</div>
			<div v-if="refresh" class="btn-refresh refresh" @click="refreshEvent"></div>
		</div>
		
		<div class="list-content">
			<div v-for="(item, index) in list" :key="index" class="list-item" v-if="list.length > 0" @click="itemClick(item)">
				<div class="list-icon"></div>
				<div class="list-label">
					<div class="label-item" v-for="l in label" :class="l.type + '-item'">
						<div v-if="l.type == 'btn'" @click="l.click(item)" v-show="!l.showFiels || item[l.showFiels[0]] == l.showFiels[1]">
							<span class="btn" :style="l.btnStyle || {}">{{l.title}}</span>
						</div>
						<div v-else>
							<span class="label-title">{{l.title}}:</span>
							<span class="label-value" v-if="l.type && l.type == 'num'" :class="item[l.field] > 0 ? 'plus': 'minus'">{{item[l.field] > 0 ? "+" + item[l.field] : item[l.field]}}</span>
							<span class="label-value" v-else-if="l.type && l.type == 'status'" :class="item['statusVal'] > 0 ? 'plus': 'minus'">{{item[l.field]}}</span>
							<span class="label-value" :style=" l.prop && l.valueStyle ? l.valueStyle[item[l.prop]] : {}" v-else>{{item[l.field]}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="noCart" v-if="list.length === 0 && page > 1">
			  <div class="pictrue"><img src="@assets/images/nodata.png" /></div>
			</div>
		</div>
		<Loading :loaded="loaded" :loading="loading"></Loading>
	</div>
</template>

<script>
import Loading from "@components/Loading";
import API from "@api/petAdmin";

export default {
  name: "List",
	components: {
	  Loading,
	},
  props: {
		options: {
			type: Object,
			default: () => {}
		},
    title: {
      type: String,
      default: ""
    },
		label : {
			type: Array,
			default: () => []
		},
		refresh: {
		  type: Boolean,
		  default : true,
		},
		noPage: {
		  type: Boolean,
		  default : false,
		},
		apiName : {
			type: String,
			default: ""
		}
  },
	data: function() {
	  return {
			loaded : false,
			loading : false,
			page: 1,
			limit: 20,
			list : [],
			filter : {},
	  };
	},
	created: function() {
	},
	mounted: function() {
		this.getList();
		this.$scroll(this.$refs.listView, () => {
			!this.loading && this.getList();
		});
	},
	methods: {
		itemClick(item) {
			this.$emit('itemClick', item)
		},
		getList() {
			let that = this;
			if (that.loading) return; 
			if (that.loaded) return;
			that.loading = true;
			let params = {page: that.page, limit: that.limit};
			API[that.apiName]({ ...params, ...that.options, ...that.filter, }).then(res => {
				this.list = this.list.concat(res.data);
				that.loading = false;
			  that.loaded = that.noPage ? true : (res.data.length < that.limit);
			  that.page = that.page + 1;
			}).catch(err => {
				that.loading = false;
				this.$dialog.error("请求失败");
			});
		},
		reload(filter) {
			this.filter = filter || {};
			this.page = 1;
			this.loaded = false;
			this.loading = false;
			this.list = [];
			this.getList();
		},
		refreshEvent() {
			console.log(123);
			this.page = 1;
			this.loaded = false;
			this.loading = false;
			this.list = [];
			this.getList();
		},
		actionEvent() {
			
		}
	}
};
</script>
<style lang="scss">
	.list-view {
		width: 100%;
		padding: 0.42rem 0rem 1.8rem;
		
		.title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-weight: 600;
			font-size: .36rem;
			color: #000000;
			padding-bottom: .16rem;
			
			.refresh {
				margin-right: .22rem;
			}
		}
		
		.list-content {
			.list-item {
				background: #FFFFFF;
				border-radius: .24rem;
				padding: 0.32rem;
				margin-top: 0.2rem;
				position: relative;
				min-height: 2.36rem;
				display: flex;
				
				.list-icon {
					width: .76rem;
					height: .76rem;
					background-size: 100%;
					background-image:url('data:image/png;base64,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');
				}
				
				.list-label {
					flex: 1;
					margin-left: 0.16rem;
					position: relative;
					.label-item {
						&:first-child {
							font-weight: 600;
							font-size: 0.28rem;
							color: #000000;
						}
						font-weight: 400;
						font-size: .22rem;
						color: #999999;
						margin-bottom: 0.08rem;
						
						.label-title {
							margin-right: 0.1rem;
						}
						
						.label-value {
							&.plus {color: #3DC60C;}
							&.minus {color: #F9372D;}
						}
						
						
						&.status-item {
							position: relative;
							left: -0.92rem;
							bottom: -0.3rem;
							
							.label-value {
								font-weight: 500;
								font-size: .34rem;
							}
						}
						
						&.num-item {
							position: absolute;
							right: 0;
							bottom: 0.57rem;
							
							.label-title {
								display: none;
							}
							
							.label-value {
								font-weight: bold;
								font-size: .36rem;
							}
						}
						
						&.date-item {
							text-align: right;
							position: relative;
							bottom: -0.16rem;
							
							.label-title {
								display: none;
							}
							.label-value {
								font-weight: 400;
								font-size: .22rem;
								color: #666666;
							}
						}
						
						&.btn-item {
							position: absolute;
							right: 0rem;
							bottom: 0.08rem;
						}
					}
				}
				
				
				.btn {
					color: #F5A100;
					font-weight: 400;
					font-size: .26rem;
					text-align: center;
					padding: 0.12rem 0.26rem;
					border-radius: 0.08rem;
					border: 0.02rem solid #F5A100;
				}
			}
		}
		
		
		
		.btn-refresh {
			width: 0.32rem;
			height: 0.32rem;
			background-size: 100%;
			background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAADoklEQVRIibWWX0xbVRzHv79z++e2w9KMDUqnLFuEtZqFBxNHsIoJAZ3ZotFhspiYPe5hmVGX+KZGwx6MZi++aUxMjDNb/LNAjMM/jFDN1PiwrBvMoYCD0i4TKYVyb2/P+flwr6zFrUALv6dzzzn38/mdc+/5Q6Zpokywxekhnu7jzAiMGc4lofLwBGnLTgq2UvgpCj8J0soA6K4CI62unFQTn8KaL/e+r5F2vUi7j1DN7jULlKmuvqNGT6GwWNRRkN4AXyOzxMIErEzJK8It9r4poq8AYjWBkZbxHr71s/Po3SqaemjHQarvgPDc7pb/hzNX1J8f819nIA2HVf+YaPuI/PfdXZBJyKGnOTcFAJpP7DkuoifgDtxx7MsmNfaBSrwNlbcT0joHKRBZTrdIYKTlQLtNp0CziH1OgT3l0MUxd0n+eJizfwCgml1aVxzebTDScrD7vylTpoz3OPT6R7Wu+DroAIKtWvdFCnUC4IVxOfwcL07KwW7OjDojUIm3VKLXzl3risMdXAd9Oaw5OdBujwPCY0+aAAAjpUZPAYDmE7EvKqQDcAe12Fm4/ACcT2ILVKIXhRwAEXmJAi0V0u3w1pHeUFwhoPJq8rTdJiKvVkU3UvKHbl4YLxFw+gKsLADRdGiVP3It9PlrK6pdnOy3S7TjYOV0QN34ikKd9o9UKsiMAAAJqu+oRiCaj965HsYMANIbSnaCjQvBuSQA1kObQQcgANoktCMgfyMAMlKbJYDeCICN9PLa22AB1UYBgBXfHNocQfiAXeLpvo2C8sxA4Xyb+v19AGQuZQtfhmFl4d3qOnCtqsVshzJlX4SXktC3u56ZEhAesfMwAJizavS9qrOHGvuQl5IAKNQF58g0UoX+KAo5aD7tiV+q2VB5cVJ+8xCsLEho+y9RoEUAgB4SkZcBQC6p+LOw5irEWxn10wvO1tl81E7UOTLFA6/Rtn0AeP66HD5UicNIFb7v5L9/BUC1EdF60iE7zcKrxc6S/14AfHNYfhv7/8ZbJjg7Jr/rwNxlAPDWifbPoPlKBQD0Bq3jnOOYvy7P71OX3yh/rQMAZaqRd+VAGy9MAIAn6Hr8a2dtAaj84qVMnv2Np86p8U9g3nIqax/UYmfonvuLeeu+OoJcyM/y4iSUdbtVuEXLMbH3dWj+FbDyl99eNXF6lVlybaGm50X0xIrE1yCwgy1OX+Dpfs5chZHiXBJcIG8d9BDVPUzbH6HwfrhqygD+BZiyqkY6h4ebAAAAAElFTkSuQmCC');
		}
		
		
		.noCart {
		  margin-top: 0.17rem;
		  padding-top: 0.1rem;
		}
		
		.noCart .pictrue {
		  width: 4rem;
		  height: 3rem;
		  margin: 0.7rem auto 0.5rem auto;
		}
		
		.noCart .pictrue img {
		  width: 100%;
		  height: 100%;
		}
	}
	
</style>
